import { NUMBERED_STEPS, SignupStep } from "./signupForm";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@verse_core/shared_components/ClassName";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

/** "STEP 1 Account info — STEP 2 …": a check for done steps, a filled square
 * for the current one and a grey square for the ones still to come. */
export const SignupStepper = ({ current }: { current: SignupStep }) => {
  const currentIndex = NUMBERED_STEPS.findIndex(({ step }) => step === current);
  const lastIndex = NUMBERED_STEPS.length - 1;

  return (
    <ol className="tw-m-0 tw-flex tw-w-full tw-list-none tw-p-0">
      {NUMBERED_STEPS.map(({ step, label }, index) => {
        const isDone = index < currentIndex;
        const isCurrent = index === currentIndex;
        return (
          <li
            key={step}
            aria-current={isCurrent ? "step" : undefined}
            className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-gap-[8px]"
          >
            <div className="tw-flex tw-w-full tw-items-center tw-gap-[10px]">
              <span
                className={cn(
                  "tw-h-px tw-flex-1",
                  index > 0 && "tw-bg-verse-border-primary",
                )}
              />
              {isDone ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  className="tw-h-[12px] tw-w-[12px] tw-text-verse-text-disabled"
                />
              ) : (
                <span
                  className={cn(
                    "tw-h-[12px] tw-w-[12px]",
                    isCurrent
                      ? "tw-bg-verse-text-primary"
                      : "tw-bg-verse-text-disabled",
                  )}
                />
              )}
              <span
                className={cn(
                  "tw-h-px tw-flex-1",
                  index < lastIndex && "tw-bg-verse-border-primary",
                )}
              />
            </div>
            <div className="tw-flex tw-items-center tw-gap-[8px] tw-whitespace-nowrap tw-leading-[1.4]">
              <span
                className={cn(
                  "tw-font-sohne-mono tw-text-[12px] tw-tracking-[0.48px]",
                  isCurrent
                    ? "tw-text-verse-text-tertiary"
                    : "tw-text-verse-text-disabled",
                )}
              >
                STEP {index + 1}
              </span>
              <span
                className={cn(
                  "tw-font-sohne tw-text-[14px] 540:tw-hidden",
                  isCurrent
                    ? "tw-text-verse-text-primary"
                    : "tw-text-verse-text-disabled",
                )}
              >
                {label}
              </span>
            </div>
          </li>
        );
      })}
    </ol>
  );
};
